import { render, staticRenderFns } from "./ManagersList.vue?vue&type=template&id=5d872305&scoped=true&"
import script from "./ManagersList.vue?vue&type=script&lang=js&"
export * from "./ManagersList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d872305",
  null
  
)

export default component.exports